import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Aggr (subrecords)',
      aggrM: 'Records',
      fields: {
      },
    }
  }
}